import { render } from "./BrandApplication.vue?vue&type=template&id=344c00ea&scoped=true"
import script from "./BrandApplication.vue?vue&type=script&lang=js"
export * from "./BrandApplication.vue?vue&type=script&lang=js"

import "./BrandApplication.vue?vue&type=style&index=0&id=344c00ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344c00ea"]])

export default __exports__